module.exports = __webpack_public_path__ + "static/beauty5-555682dd0dab2ec7b2061fcdcd4452c3.jpg";